import React from "react";
import { Button, Row, Card, Form, Input, Image, message } from "antd";
import { Route, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./Login.css";
import apis from "../../services/apis";
import { useApiContext } from "../../hooks/useApiContext";
import helper from "../../";
import { setStorageItem } from "../../utils/helper";

export default function Login() {
  const [loginForm] = Form.useForm();
  const { logindispatch, user } = useApiContext();
  const navigate = useNavigate();
  const onFinish = async (values) => {
    if (
      values.username == "admin" &&
      values.password == "Mamun@550055"
    ) {
      let newValues = { ...values, role: "admin" };
      apis.Account.login(logindispatch, newValues);
      setStorageItem(localStorage,"userRole", "admin", (res, err) => {
      });
      setStorageItem(localStorage, "auth_key", "xxaa1112jnj", (res, err) => {
        navigate("/home");
      });
    } else if (
      values.username == "DataEntry" &&
      values.password == "Mamun@197813"
    ) {
      let newValues = { ...values, role: "user" };
      apis.Account.login(logindispatch, newValues);
      setStorageItem(localStorage, "auth_key", "astrfh126643", (res, err) => {
        navigate("/home");
      });
    } else if (values.username == "HR" && values.password == "Mamun@197813") {
      let newValues = { ...values, role: "HR" };
      apis.Account.login(logindispatch, newValues);
      setStorageItem(localStorage, "auth_key", "kjnmgh22578", (res, err) => {
        navigate("/home");
      });
    }
    // if(values.username=="admin" && values.password=="admin123")
    // {
    //   let newValues = {...values, role:'admin'}
    //   apis.Account.login(logindispatch, newValues)
    //   navigate('/home')
    // }
    // else if(values.username =="Dataentry" && values.password=="Best@276233"){
    //   let newValues ={...values, role:'user'}
    //   apis.Account.login(logindispatch, newValues)

    // }
    // else if(values.username =="staff2022" && values.password=="Best@276233"){
    //   let newValues ={...values, role:'user'}
    //   apis.Account.login(logindispatch, newValues)
    //   navigate('/home')
    // }
    else {
      loginForm.resetFields();
      window.location.reload();
      message.error("Please check Username and Password");
    }
    // apis.Account.login(logindispatch, values).then((res) => {
    //   console.log("Login", user);
    // });
    //navigate('/home')
  };
  const onFinishFailed = (error) => {
    console.log(error);
  };
  console.log("user details", user);
  return (
    <section className="bg-home bg-circle-gradiant d-flex align-items-center">
      <div className="bg-overlay bg-overlay-white">
        <Row>
          <div className="login-box">
            <Card>
              <Image
                className="ant-image"
                preview={false}
                src={logo}
                width={150}
              />
              <h2 style={{ textAlign: "center" }}>Login</h2>
              <Form
                initialValues={{ remember: true }}
                name="basic"
                form={loginForm}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="gx-signin-form gx-form-row0"
              >
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "The input your username!",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please input your Password!" },
                  ]}
                >
                  <Input type="password" placeholder="Password" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    Log in
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Row>
      </div>
    </section>
  );
}
